import { render, staticRenderFns } from "./screens.vue?vue&type=template&id=debd930a"
import script from "./screens.vue?vue&type=script&lang=js"
export * from "./screens.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports